__turbopack_context__.v({
  "menuWrapper": "rUCWXG_menuWrapper",
});
